var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxbolddataUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,9c0,1.1-0.8,1.9-1.9,1.9c0,0-0.1,0-0.1,0c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-2,2-2S7.8,7.9,7.8,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,16.2c-1.3-0.9-1.3-2.3,0-3.2c1.5-1,4-1,5.5,0c1.3,0.9,1.3,2.3,0,3.2C7,17.2,4.6,17.2,3.1,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,14.2c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,14.2,20,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.2c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,6.2,20,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22.2c-1.2,0-2.2-1-2.2-2.2 s1-2.2,2.2-2.2s2.2,1,2.2,2.2S21.2,22.2,20,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,12c0-0.4-0.3-0.8-0.8-0.8h-7c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h7C18.4,12.8,18.8,12.4,18.8,12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,19.2h-1.2c-1.6,0-2.2-0.7-2.2-2.2V7c0-1.6,0.7-2.2,2.2-2.2H18c0.4,0,0.8-0.3,0.8-0.8S18.4,3.2,18,3.2 h-1.2c-1.5,0-2.6,0.5-3.2,1.5C13.2,5.4,13,6.1,13,7v10c0,0.9,0.2,1.6,0.5,2.2c0.6,1,1.7,1.5,3.2,1.5H18c0.4,0,0.8-0.3,0.8-0.8 S18.4,19.2,18,19.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxbolddataUser);
export default __webpack_public_path__ + "static/media/vuesaxbolddata-user.7aad9285eed40bed789f383be8649d28.svg";
export { ForwardRef as ReactComponent };